import { render, staticRenderFns } from "./AddInstruction.vue?vue&type=template&id=28962d18"
import script from "./AddInstruction.vue?vue&type=script&lang=js"
export * from "./AddInstruction.vue?vue&type=script&lang=js"
import style0 from "./AddInstruction.vue?vue&type=style&index=0&id=28962d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports